import {
  useNoBuses,
} from '@src/modules/performance/context/reports-api-hooks';

import { Link, Text } from '@chakra-ui/react';
import LineChart from '@src/modules/performance/components/charts/LineChart';
import { CHART_COLOURS } from '@src/modules/performance/shared/constants';
import ReportSection from './ReportSection';

const informationSource = {
  title: 'Public Transport Fleet Size',
  content: [
    {
      title: 'No. of Buses',
      description:
  <Text fontSize="inherit" mb={2}>
    The number of buses in the fleet during the year.
  </Text>,
      source:
  <Text fontSize="inherit" as="span">
    Sourced from
    {' '}
    <Link href="https://www.nzta.govt.nz/planning-and-investment/learning-and-resources/transport-data/data-and-tools/" isExternal>NZTA Data and Tools, use - public transport</Link>
  </Text>,
    },
  ],
};

function PublicTransportFleetSize() {
  const { data: noBuses, isLoading } = useNoBuses();

  const years = [...new Set(noBuses?.map((item) => item.Year))];
  const noBusesChartData = [
    {
      name: 'No. of Buses',
      type: 'line',
      data: noBuses?.map((item) => ({
        x: item.Year,
        y: item.FleetSizeCount,
      })),
      color: CHART_COLOURS.blue,
    },
  ];

  return (
    <ReportSection
      title="Public Transport Fleet Size"
      isLoading={isLoading || !noBuses}
      informationSource={informationSource}
      lockYear={noBuses?.[0]?.LockYear}
    >
      <LineChart
        title="No. of Buses"
        categories={years}
        series={noBusesChartData}
        width="220"
        height="280"
        decimalPoints={2}
        yAxisDecimalPoints={2}
      />
    </ReportSection>
  );
}

export default PublicTransportFleetSize;
